/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  VirtualRTAzzurroHubTarget,
  startVirtualRTAzzurroHubResponse,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface VRTManagementAzzurroHubInput {
  transactionId: string;
  loggerId: string;
  active: boolean;
  target: VirtualRTAzzurroHubTarget;
  duration?: number;
}
const build = (_query: DocumentNode, input: VRTManagementAzzurroHubInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.transactionId !== undefined ? `$transactionId: String = ${JSON.stringify(input.transactionId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.loggerId !== undefined ? `$loggerId: String = ${JSON.stringify(input.loggerId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.active !== undefined ? `$active: Boolean = ${JSON.stringify(input.active).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.target !== undefined ? `$target: VirtualRTAzzurroHubTarget = ${input.target}, ` : '' ) + ``+
    ( input.duration !== undefined ? `$duration: Int = ${JSON.stringify(input.duration).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    VRTManagementAzzurroHub(
      ${ input.transactionId !== undefined ? 'transactionId: $transactionId,' : '' } 
      ${ input.loggerId !== undefined ? 'loggerId: $loggerId,' : '' } 
      ${ input.active !== undefined ? 'active: $active,' : '' } 
      ${ input.target !== undefined ? 'target: $target,' : '' } 
      ${ input.duration !== undefined ? 'duration: $duration,' : '' }
    ){
      ...startvirtualrtazzurrohubresponse
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class VRTManagementAzzurroHubMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment startvirtualrtazzurrohubresponse on startVirtualRTAzzurroHubResponse { ... }
   */
  async execute(_query: DocumentNode, input: VRTManagementAzzurroHubInput): Promise<apollo.FetchResult< { VRTManagementAzzurroHub: Partial<startVirtualRTAzzurroHubResponse> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ VRTManagementAzzurroHub: Partial<startVirtualRTAzzurroHubResponse> }>({ mutation: build(_query, input) });
  }
}
